export default {
  meta: {
    title: '选址地图-本品牌门店',
    url: '/sitemap/clusterstores', // 埋点字段，上报归属的模块
    urlName: '选址地图' // 埋点字段，上报归属的模块
  }
};
